<template>
  <div>
    <div class="card">
      <div class="bg-blue-light px-1 rounded pb-2">
        <TitleButton
            class="mt-1"
            btnTitle="List"
            :showBtn="true"
            :showAddNew="false"
            :title="(projectId === '') ? 'Add New Project' : 'Edit Project'"
            @onClickCloseButton="navigateToListPage"
        />
 
        <div class="row mt-2 gy-1">
          <div class="row mt-1">
            <div class="col-sm-4">
              <label class="align-middle">Project Name</label>
              <input type="text" class="form-control" v-model="formData.name">
            </div>
            <div class="col-sm-4">
              <label class="align-middle">Project Code</label>
              <input type="text" class="form-control" v-model="formData.code">
            </div>
            <div class="col-sm-4">
              <label class="align-middle">Create Date</label>
              <input type="date" class="form-control" v-model="formData.date">
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-sm-4">
              <label class="align-middle">Business Line</label>
              <v-select
                  placeholder="Select Business"
                  v-model="formData.business_id"
                  :options="businessLines"
                  label="name"
                  :reduce="name => name.id"
              />
            </div>
            <div class="col-sm-4">
              <label class="align-middle">Start Date</label>
              <input type="date" class="form-control" v-model="formData.start_date">
            </div>
            <div class="col-sm-4">
              <label class="align-middle">End Date</label>
              <input type="date" class="form-control" v-model="formData.end_date">
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-sm-4">
              <label class="align-middle">Party</label>
              <AsyncSelect
                  placeholder="Select Party"
                  v-model="formData.party_id"
                  :api-service="fetchParties"
                  label="name"
                  :reduce="name => name.id"
                  :additional-option="partyOptions"
              />
            </div>
            <div class="col-sm-4">
              <label class="align-middle">Interval</label>
              <v-select
                placeholder="Select Interval"
                v-model="formData.interval"
                :options="intervals"
                label="name"
                :reduce="name => name.id"
              />
              <span v-if="errors.hasOwnProperty('interval')" class="invalid-feedback d-block qcont">{{ errors.interval[0] }}</span>
            </div>
            <div class="col-sm-4">
              <label class="align-middle">Link Warehouse</label>
              <v-select
                  placeholder="Select Warehouse"
                  v-model="formData.business_location_id"
                  :options="warehouses"
                  label="text"
                  :reduce="text => text.id"
              />
            </div>
            <div class="col-sm-4" v-if="projectId">
              <label class="align-middle">Project Type</label>
              <v-select
                  placeholder="Select Project Type"
                  v-model="formData.project_type"
                  :options="projectTypes"
                  label="name"
                  :reduce="type => type.id"
              />
            </div>
            <div class="col-sm-4" v-if="projectId">
              <label class="align-middle">Status</label>
              <v-select
                  placeholder="Select Status"
                  v-model="formData.status"
                  :options="statusList"
                  label="name"
                  :reduce="name => name.id"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="px-1 rounded pb-2">
        <TitleButton
            class="mt-1"
            btnTitle="Add New"
            :showBtn="false"
            :showAddNew="true"
            title="Project Revenue"
            @onClickAddNewButton="showProjectRevenue"
        />

        <div class="row mt-1" v-if="formData.is_project_revenue">
          <div class="col-sm-4 mb-1">
            <label class="align-middle">Total Amount</label>
            <input type="text" class="form-control" v-model="formData.total_amount">
          </div>
          <div class="col-sm-4 mb-1">
            <label class="align-middle">Booking Amount</label>
            <input type="text" class="form-control" v-model="formData.booking_money">
          </div>
          <div class="col-sm-4 mb-1">
            <label class="align-middle">Down Payment</label>
            <input type="text" class="form-control" v-model="formData.down_payment">
          </div>
          <div class="col-sm-4 mb-1">
            <label class="align-middle">Remaining Amount</label>
            <input type="text" class="form-control" readonly v-model="remainingAmount">
          </div>
          <div class="col-sm-4 mb-1">
            <label class="align-middle">Number Of Installment</label>
            <input type="text" class="form-control" v-model="formData.number_of_installment">
          </div>
          <div class="col-sm-4 mb-1">
            <label class="align-middle">Installment Amount</label>
            <input type="text" class="form-control" readonly v-model="installmentAmount">
          </div>
          <div class="col-sm-4 mb-1">
            <label class="align-middle">Installment Frequency</label>
            <v-select
                placeholder="Select Installment Frequency"
                v-model="formData.installment_frequency"
                :options="intervals"
                label="name"
                :reduce="name => name.id"
            />
          </div>
        </div>

      </div>
    </div>

    <div class="card">
      <div class="px-1 rounded pb-2">
        <TitleButton
            class="mt-1"
            btnTitle="Add New"
            :showBtn="false"
            :showAddNew="true"
            title="Team Member"
            @onClickAddNewButton="showNewTeamMemberModal"
        />

        <TeamMemberTable
            :project-teams="formData.project_teams"
            @removeItem="removeItem"
        />

      </div>
    </div>

    <div class="card">
      <div class="px-1 rounded pb-2" v-if="formData.id">
        <TitleButton
            class="mt-1"
            btnTitle="Add New"
            :showBtn="false"
            :showAddNew="true"
            title="Project Accounts"
            @onClickAddNewButton="onClickNewAccountGroupModal"
        >
          <template #extra-btn>
            <template v-if="hasTabData">
              <button
                  v-if="!templateSavedTabs.has(currentTabTemplateType)"
                  @click="onClickMakeTemplate"
                  class="btn btn-sm btn-outline-info waves-effect waves-float waves-light me-1"
              >Make Template</button>
              <template v-else>
                <button
                    @click="onClickRemoveTemplate"
                    class="btn btn-sm btn-outline-danger waves-effect waves-float waves-light me-1"
                >Remove Template</button>
              </template>
            </template>
            <div v-if="!hasTabData" style="width:280px">
              <AsyncSelect
                  :key="currentTabTemplateType"
                  placeholder="Select Template"
                  v-model="selectedTemplate"
                  :additional-query="{ template_type: currentTabTemplateType }"
                  :api-service="fetchTemplates"
              />
            </div>
          </template>
        </TitleButton>

        <div class="row gy-1">
          <section id="basic-tabs-components">
            <div class="row match-height">
              <div class="col-12">
                <ul class="nav nav-tabs" role="tablist">
                  <li
                      class="nav-item"
                      :class="`${accountType == tab.id ? 'active' : ''}`"
                      v-for="(tab, i) in tabs"
                      :key="i"
                      @click="onClickTab(tab.id, tab.name)"
                      type="button"
                  >
                    <a :class="`${accountType == tab.id ? 'active' : ''}`" class="nav-link" data-bs-toggle="tab"
                       aria-controls="home" role="tab" aria-selected="true">{{ tab.name }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>

      </div>

      <div class="card-body">
        <div class="row d-flex flex-wrap justify-content-between align-items-center">
          <TreeBrowser
              v-if="projectAccountList.group"
              :key="accountType + treeKey"
              :style="{opacity: chartLoading ? .5 : 1}"
              :groupData="projectAccountList.group"
              :endpointData="projectAccountList.endpoint"
              :accountType="accountType"
              @onClickAddGroup="handleAddGroupClick"
              @onGroupUpdate="handleGroupUpdate"
              @onClickAddAccount="handleAddAccountClick"
              @onAccountUpdate="handleAccountUpdate"
              @paginationEmit="handleRootPagination"
          />
        </div>
      </div>

      <div class="mt-2 d-flex justify-content-start justify-content-sm-center px-2 gap-1 flex-wrap pb-2">
        <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="handleSubmit(true)"
                class="btn btn-primary">
          Save
        </button>
        <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="handleSubmit(false)"
                class="btn btn-primary">Save & New
        </button>
        <button @click="navigateToListPage" class="btn btn-outline-secondary">Cancel</button>
      </div>
      <GlobalLoader/>
    </div>

    <AddTempleModal
        v-if="store.state.isModalOpenTwo"
        modalOpen="isModalOpenTwo"
        :templateableId="parseInt(formData.id)"
        :templateType="currentTabTemplateType"
        @onSubmit="onTemplateSaved"
    />

    <ProjectAccountTemplateModal
        v-if="showTemplatePreviewModal"
        :template="selectedTemplate"
        :accountType="templatePreviewAccountType"
        :projectId="formData.id"
        @onClose="showTemplatePreviewModal = false; selectedTemplate = null"
        @onDeleted="onTemplateDeleted"
        @onSaved="onTemplateSavedToProject"
    />

    <TeamMemberModal
        modalTitle="Add Team Member"
        ref="teamMember"
        :roles="roleList"
        @onSubmitForm="handleTeamMemberSubmit"
    />
    <AccountGroupModal
        :modal-title="accountTypeName"
        ref="accountGroup"
        :query="getQuery()"
        :project-account-level="projectAccountLevel"
        :types="homeContent.project_account_type"
        :project-type="homeContent.project_type"
        :project-account-status="homeContent.project_account_status"
        :account-type="accountType"
        :project-id="formData.id"
        :unitList="unitList"
        :accountHeads="accountHeads"
        :fd6AccountHeads="fd6AccountList"
        :programs="programList"
        :showParent="showParent"
        :form="accountGroupForm"
        :accounts="allAccountGroups"
        @onAccountSave="handleProjectAccountSubmit"
        @onCloseGroupModal="resetAccountModalForm"
    />

  </div>
</template>
<script setup>
import {computed, inject, onMounted, ref, watch} from 'vue';
import {useRoute, useRouter} from "vue-router";
import TitleButton from '@/components/atom/TitleButton';
import handleProjects from "@/services/modules/procurement/project";
import TeamMemberModal from "@/components/molecule/procurement/project/TeamMemberModal";
import TeamMemberTable from "@/components/molecule/procurement/project/TeamMemberTable.vue";
import handleInventory from "@/services/modules/inventory";
import TreeBrowser from "@/components/molecule/procurement/project/TreeBrowser";
import AccountGroupModal from "@/components/molecule/procurement/project/AccountGroupModal";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleDropdowns from "@/services/modules/dropdowns";
import handleTemplate from '@/services/modules/all-modules/template';
import AddTempleModal from '@/components/molecule/company/hospital/prescription/AddTempleModal.vue';
import ProjectAccountTemplateModal from '@/components/molecule/procurement/project/ProjectAccountTemplateModal.vue';
import { useStore } from 'vuex';

const router = useRouter();
const route = useRoute();
const store = useStore();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const emitter = inject('emitter');

let teamMember = ref(null);
let accountGroup = ref(null);
let loader = ref(false);
let saveButtonLoader = ref(false);
let saveNewButtonLoader = ref(false);
let businessLines = ref([]);
let accountType = ref('item');
let currentTabTemplateType = ref('project_account_item');
let accountTypeName = ref('Item');
let projectAccountList = ref([]);
let treeKey = ref(0);
let homeContent = ref({});
let showParent = ref(false);
let allAccountGroups = ref([]);
let warehouses = ref([])
let projectAccountLevel = ref('group');
let errors = ref({});
let unitList = ref([]);
let accountHeads = ref([]);
let fd6AccountList = ref([]);
let programList = ref([]);
let roleList = ref([]);
let { chartLoading } = handleInventory();

let showTemplatePreviewModal = ref(false);
let selectedTemplate = ref(null);
let templatePreviewAccountType = ref('');
let templateSavedTabs = ref(new Set());
let removingTemplate = ref(false);
const { fetchDropdownList } = handleDropdowns();
const { fetchTemplates, removeTemplate, checkTemplate } = handleTemplate();

let {
  fetchParties,
  fetchBusinesses,
  createNewProject,
  fetchProjectForm,
  fetchProjectAccountTree,
  createProjectAccountGroup,
  createProjectAccount,
  updateProjectAccountGroup,
  updateProjectAccount,
  fetchProjectGroups,

  fetchAccountTree,
  fetchProjectAccount,
  updateProject,
} = handleProjects();
let formData = ref({
  name: null,
  code: null,
  date: null,
  business_id: null,
  business_location_id: null,
  start_date: null,
  end_date: null,
  party_id: null,
  interval: null,
  status: 'active',
  project_teams: [],
  is_project_revenue: false,
  project_type: null,
  total_amount: null,
  booking_money: null,
  down_payment: null,
  number_of_installment: null,
  installment_frequency: null,
  type: 'installment',
})
let accountGroupForm = ref({
  linked_item_id: "",
  linked_account_id: "",
  name: "",
  code: "",
  description: "",
  exp_account_type: "",
  project_account_id: "",
  project_account_type: "",
  fd6_account_id: "",
  project_type: "",
  status: 'active',
});

function navigateToListPage() {
  route.params.projectId = null;
  let routeName = 'project-list';
  if (route.query.type && route.query.type == 'job_register'){
    routeName = 'job-register';
  }
  router.push({name: routeName, params: route.params, query: { ...route.query, page: 1}});
}

const remainingAmount = computed(() => {
  const total = formData.value.total_amount || 0
  const booking = formData.value.booking_money || 0
  const down = formData.value.down_payment || 0

  const remaining = total - booking - down
  return remaining > 0 ? remaining : 0
})

const installmentAmount = computed(() => {
  const count = formData.value.number_of_installment || 0

  if (count > 0) {
    return (remainingAmount.value / count).toFixed(2)
  }

  return 0
})

function handleSubmit(redirect = false) {
  if (redirect) {
    saveButtonLoader.value = true
  } else {
    saveNewButtonLoader.value = true
  }

  let res = null;
  if (projectId.value) {
    formData.value.type = 'installment'
    res = updateProject(projectId.value, getQuery(), formData.value);
  } else {
    res = createNewProject(getQuery(), formData.value);
  }

  res.then(res => {
    saveButtonLoader.value = false
    saveNewButtonLoader.value = false

    if (!res.status) {
      showError(res.message)
    }

    showSuccess(res.message)

    if (redirect) {
      navigateToListPage();
      return;
    }

    resetForm()
    lastFetchedType.value = null;
    getAccountTree();
    
  })
      .catch(err => {
        errors.value = err.response.data.errors;
        showError(err.response.data.message);
        saveButtonLoader.value = false;
        saveNewButtonLoader.value = false;
      })
}

function showProjectRevenue() {
  formData.value.is_project_revenue = true
}

function showNewTeamMemberModal() {
  teamMember.value?.toggleModal()
}

function showAddAccountModal() {
  if (showParent.value) {
    getProjectGroups();
  }
  accountGroup.value?.toggleModal()
}

async function onClickTab(tab, name) {
  accountType.value = tab;
  currentTabTemplateType.value = `project_account_${accountType.value}`
  accountTypeName.value = name;
  projectAccountList.value = [];
  selectedTemplate.value = null;
  getAccountTree();
  await syncTemplateStatus(tab);
}

async function syncTemplateStatus(tab) {
  if (!formData.value.id) return;
  const templateType = `project_account_${tab}`;
  const query = `?company_id=${route.params.companyId}&template_type=${templateType}`;
  const res = await checkTemplate(formData.value.id, query).catch(() => null);
  if (!res.status) return;
  if (res.data.exists) {
    templateSavedTabs.value.add(templateType);
  }
  if (!res.data.exists) {
    templateSavedTabs.value.delete(templateType);
  }
}

function handleTeamMemberSubmit(newTeamMember) {
  if (!formData.value.project_teams) {
    formData.value.project_teams = [];
  }
  formData.value.project_teams.push(newTeamMember);
}

function removeItem(itemIndex) {
  formData.value.project_teams.splice(itemIndex, 1);
}

function getQuery() {
  let query = `?company_id=${route.params.companyId}`;
  query += `&from_project=1`

  if (!accountType.value) {
    return query;
  }

  let type = accountType.value;
  if (type === 'activity_target') {
    return query + `&account_type=activity&project_type=task,donor_kpi`;
  }

  if (type === 'activity_budget') {
    return query + `&account_type=activity`;
  }

  return query + `&account_type=${type.toLowerCase()}`;
}

function resetForm() {
  formData.value = {
    name: null,
    code: null,
    date: null,
    business_id: null,
    business_location_id: null,
    start_date: null,
    end_date: null,
    party_id: null,
    project_teams: [],
    is_project_revenue: false,
    project_type: null,
    total_amount: null,
    booking_money: null,
    down_payment: null,
    number_of_installment: null,
    installment_frequency: null,
    type: 'installment',
  }
}

function resetAccountModalForm() {
  accountGroupForm.value = {
    linked_item_id: "",
    linked_account_id: "",
    name: "",
    code: "",
    description: "",
    exp_account_type: "",
    project_account_id: "",
    project_account_type: "",
    project_type: "",
    status: 'active',
  };
  showParent.value = false;
  projectAccountLevel.value = 'group';
}

async function getAccountTree() {
  try {
    const res = await fetchAccountTree(projectId.value, getQuery());

    if (res.status) {
      projectAccountList.value = res.data;
      treeKey.value++;
    }
  } catch (err) {
    console.error(err);
  }
}

async function handleRootPagination(page) {
  try {
    let query = getQuery() + `&page=${page}&offset=1`;
    const res = await fetchAccountTree(projectId.value, query);

    if (res.status) {
      projectAccountList.value.endpoint = res.data.endpoint;
    }
  } catch (err) {
    console.error(err);
  }
}

let lastFetchedType = ref(null);
async function getProjectGroups(force = false) {
  if (!force && lastFetchedType.value === accountType.value && allAccountGroups.value.length > 0) {
    return;
  }

  try {
    const res = await fetchProjectGroups(projectId.value, getQuery());
    if (res.data) {
      allAccountGroups.value = res.data;
      lastFetchedType.value = accountType.value;
    }
  } catch (err) {
    console.error(err);
  }
}

function onClickNewAccountGroupModal() {
  showAddAccountModal();
  projectAccountLevel.value = 'group';
  accountGroupForm.value.exp_account_type = 'expense';
}

async function handleAccountSave() {
  if (accountGroupForm.value.id) {
    return await updateProjectAccount(accountGroupForm.value.id, getQuery(), accountGroupForm.value);
  } else {
    return await createProjectAccount(getQuery(), accountGroupForm.value);
  }
}

async function handleGroupSave() {
  if (accountGroupForm.value.id) {
    return await updateProjectAccountGroup(accountGroupForm.value.id, getQuery(), accountGroupForm.value);
  } else {
    return await createProjectAccountGroup(getQuery(), accountGroupForm.value);
  }
}

async function handleProjectAccountSubmit() {
  let res = null;
  accountGroupForm.value.project_id = projectId.value;
  if (projectAccountLevel.value == 'group') {
    res = await handleGroupSave();
  } else {
    res = await handleAccountSave();
  }

  if (!res.status) {
    showError(res.message);
  } else {
    showSuccess(res.message);
    resetAccountModalForm();
    showAddAccountModal();
    
    lastFetchedType.value = null;
    await getAccountTree();
  }
}

const tabs = computed(() => {
  let tabs = [];

  if (!homeContent.value.project_account_type) {
    return tabs;
  }

  Object.keys(homeContent.value.project_account_type).forEach(key => {
    if (key === 'activity') {
      tabs.push({ id: 'activity_budget', name: 'Activity Budget' });
      tabs.push({ id: 'activity_target', name: 'Activity Target' });
      return;
    }
    tabs.push({ id: key, name: homeContent.value.project_account_type[key] });
  });

  return tabs;
})

const hasTabData = computed(() => {
    const list = projectAccountList.value;
    if (!list) return false;
    return Array.isArray(list.group) && list.group.length > 0;
});

function onClickMakeTemplate() {
    store.state.isModalOpenTwo = true;
}

function onTemplateSaved() {
    store.state.isModalOpenTwo = false;
    templateSavedTabs.value.add(currentTabTemplateType.value);
}

function onTemplateDeleted() {
    showTemplatePreviewModal.value = false;
    selectedTemplate.value = null;
    if (templatePreviewAccountType.value) {
        templateSavedTabs.value.delete(`project_account_${templatePreviewAccountType.value}`);
    }
}

async function onTemplateSavedToProject() {
    showTemplatePreviewModal.value = false;
    selectedTemplate.value = null;
    lastFetchedType.value = null;
    await getAccountTree();
}

async function onClickRemoveTemplate() {
    if (!confirm('Are you sure you want to remove this template?')) return;
    removingTemplate.value = true;
    const query = `?company_id=${route.params.companyId}&template_type=${currentTabTemplateType.value}`;
    const res = await removeTemplate(query, formData.value.id).catch(() => null);
    removingTemplate.value = false;
    if (!res.status) {
        showError(res.message);
        return;
    }
    showSuccess(res.message);
    templateSavedTabs.value.delete(currentTabTemplateType.value);
}

watch(selectedTemplate, (tpl) => {
    if (!tpl) return;
    templatePreviewAccountType.value = accountType.value;
    showTemplatePreviewModal.value = true;
});

const partyOptions = computed(() => {
  if (formData.value.party && formData.value.party.id) {
    return [
      {
        id: formData.value.party.id,
        name: formData.value.party.name
      }
    ]
  }
  return []
})

const projectId = computed(() => {
  return route.params.projectId ? route.params.projectId : '';
});

const intervals = computed(() => {
  let intervals = [];
  if(homeContent.value.hasOwnProperty('project_intervals')) {
    Object.keys(homeContent.value.project_intervals).forEach( id => {
      intervals.push({
        id: id,
        name: homeContent.value.project_intervals[id],
      })
    })
  }
  return intervals;
})

const projectTypes = computed(() => {
  let list = [];
  if (homeContent.value.hasOwnProperty('project_type')) {
    Object.keys(homeContent.value.project_type).forEach(id => {
      list.push({
        id: id,
        name: homeContent.value.project_type[id],
      })
    })
  }
  return list;
});

const statusList = computed(() => {
  const allowedStatuses = ['active', 'inactive', 'completed'];
  const list = [];

  if (homeContent.value.hasOwnProperty('status')) {
    Object.keys(homeContent.value.status).forEach(id => {
      if (allowedStatuses.includes(id)) {
        list.push({
          id: id,
          name: homeContent.value.status[id],
        });
      }
    });
  }

  return list;
});

const handleAddGroupClick = (event) => {
  accountGroupForm.value.project_account_id = event.id;
  accountGroupForm.value.project_account_type = event.project_account_type;
  showParent.value = true;
  projectAccountLevel.value = 'group';
  showAddAccountModal();
};

const handleGroupUpdate = async (data) => {
  const res = await fetchProjectAccount(data.id, getQuery());
  if (res.status) {
    accountGroupForm.value = res.data;
  }

  showParent.value = data.group_level != 1;
  projectAccountLevel.value = 'group';
  showAddAccountModal();
};

const handleAddAccountClick = (event) => {
  accountGroupForm.value.project_account_id = event.id;
  accountGroupForm.value.project_account_type = event.project_account_type;
  showParent.value = true;
  projectAccountLevel.value = 'account';
  showAddAccountModal();
};

const handleAccountUpdate = async (data) => {
  const res = await fetchProjectAccount(data.id, getQuery());
  if (res.status) {
    accountGroupForm.value = res.data;
  }
  showParent.value = true;
  projectAccountLevel.value = 'account';
  showAddAccountModal();
};

onMounted(async () => {
  const companyId = route.params.companyId;
  const consolidatedQuery = `?company_id=${companyId}&is_business=1&is_home=1&is_unit=1&is_business_location=1&from_project=1&is_all_account_heads=1&is_fd6_accounts=1&is_program=1&is_role=1`;

  loader.value = true;
  await fetchDropdownList(consolidatedQuery).then(res => {
    if (res.status && res.data) {
      businessLines.value = res.data.business_list;
      homeContent.value = res.data.home_data;
      unitList.value = res.data.unit_list;
      warehouses.value = res.data.business_location_list;
      accountHeads.value = res.data.account_heads;
      fd6AccountList.value = res.data.fd6_account_list;
      programList.value = res.data.program_list;
      roleList.value = res.data.company_role_list;
    }
  }).catch((err) => {
    console.error(err);
  }).finally(() => {
    loader.value = false;
  });

  if (projectId.value) {
    const res = await fetchProjectForm(projectId.value, getQuery());
    if (res.status) {
      if(res.data.business_location){
        warehouses.value.push(res.data.business_location)
      }
      
      formData.value = res.data;
      if (!formData.value.project_teams) {
        formData.value.project_teams = [];
      }
      if (res.data.project_revenue_installment){
        let installmentAmount = res.data.project_revenue_installment;
        formData.value.is_project_revenue = true;
        formData.value.total_amount = installmentAmount.total_amount || 0;
        formData.value.booking_money = installmentAmount.booking_money || 0;
        formData.value.down_payment = installmentAmount.down_payment || 0;
        formData.value.number_of_installment = installmentAmount.number_of_installment || 0;
        formData.value.installment_frequency = installmentAmount.installment_frequency || 0;
        formData.value.type = 'installment';
      }
      await getAccountTree();
      await syncTemplateStatus(accountType.value);
    }
  }
});

</script>
